export default __webpack_public_path__ + "static/media/ucy_symbol.029c87ea.png";